import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { loadAdminType, loadAdminTypeSuccess } from './adminType.actions';
import { ApiResponse } from '@shared';
import { ToastrService } from 'ngx-toastr';
import { SystemAdminService } from '@services';
import { IPaginationParams } from '@interfaces';

@Injectable()
export class AdminTypeEffects {
  constructor(
    private actions$: Actions,
    private systemAdminService: SystemAdminService,
    private toast: ToastrService,
  ) {}
  loadAdminType$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadAdminType),
      mergeMap(() =>
        this.systemAdminService.getAllTypes({ pageNum: 1, pageLimit: 'all' } as IPaginationParams).pipe(
          map((response: ApiResponse) => {
            if (response.status) {
              const adminType = response.data.map((item: any) => ({
                _id: item._id,
                name: item.typeName,
              }));
              return loadAdminTypeSuccess({ adminType });
            } else {
              this.toast.error(response.message);
              return { type: '[AdminType] Load Admin type Failure' };
            }
          }),
          catchError((error: any) => {
            this.toast.error(error);
            return of({ type: '[AdminType] Load Admin type Failure' });
          }),
        ),
      ),
    ),
  );
}
